// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"az_xSb","containerRightFrame":"az_ySb","outerContainer":"az_zSb","table":"az_ASb","tableHeadCellSticky":"az_BSb","tableRow":"az_CSb","tableCell":"az_DSb"};